import { h } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import { useSelector } from 'react-redux';
import { MQC_BANNER } from 'common/constants/images-mqc';
import translator from 'common/i18n';
import { getVideoDuration } from 'common/helpers/videos';
import LazyImage from 'common/components/lazy-image/lazy-image';
import SeriesLogo from 'common/components/series-logo';
import VideoMetaData from 'common/components/videos/video-meta-data';
import VideoPlayer from 'sites/expedia-dominican-republic/video-player/js/video-player';

import * as Styled from '../styles/styles';

export default function InlineVideo({data}) {
    const { thumbnail, video, seriesLogo, metadata, hideSeriesLogo, ctaLink, ctaText } = data;
    const accessibilityOptions = useSelector(state => state.accessibilityOptions);
    const isDesktopSmall = useSelector( state => state.ui.isDesktopSmall );
    const [ descriptionHeight, setDescriptionHeight ] = useState( 0 );
    const [ watchProgress, setWatchProgress ] = useState( null );
    const [ inlinePlay, setInlinePlay ] = useState(false);
    const descriptionElement = useRef( null );
    const episodesLabel = metadata['episode-number'] ? translator.lookup('label.channel.episode-number', { number: metadata['episode-number'] }) : translator.lookup('label.video-trailer');


    useEffect( () => {
        const ctaHeight = ( ctaText !== '' && ctaLink !== '' ) ? 60 : 0;

        if(video.description && descriptionElement.current) {
            setDescriptionHeight( descriptionElement.current.offsetHeight + ctaHeight );
        }

    }, [ descriptionElement.current ] );

    useEffect( () => {
        const progress = localStorage.getItem( `video-progress-${ video.id }` );
        if ( progress ) {
            setWatchProgress( parseInt( progress ) );
        }
    }, [ video.id ] );

    const handleVideoAction = () => {
        setInlinePlay( !inlinePlay );
    };
    
    return (
        <Styled.VideoPromo className={ inlinePlay && 'is-active' }>
            <Styled.ImageContainer >
                { thumbnail &&
                    <LazyImage
                        image={ thumbnail }
                        mediaQueryConfig={ MQC_BANNER } 
                    />
                }
                {(seriesLogo?.url && !hideSeriesLogo && !isDesktopSmall) && <SeriesLogo logoImg={seriesLogo.url} altText={ seriesLogo.title } />}
            </Styled.ImageContainer>

            <VideoPlayer data={ { ...data, inline: true, inlinePlay } } />

            <Styled.Content>

                { (metadata?.[ 'series-name' ] && hideSeriesLogo || !seriesLogo?.url) && <Styled.SeriesTitle >{ metadata[ 'series-name' ] }</Styled.SeriesTitle> }
                
                {(seriesLogo?.url && !hideSeriesLogo && isDesktopSmall) && <SeriesLogo logoImg={seriesLogo.url} altText={ seriesLogo.title } />}

                { metadata?.[ 'channel-name' ] && <Styled.ChannelName >{ metadata[ 'channel-name' ] }</Styled.ChannelName> }

                <Styled.PlayCta 
                    className='plays-inline' 
                    theme='light' 
                    descriptionHeight={ descriptionHeight } 
                    inlinePlay={ inlinePlay } 
                    accessibilityDarkMode={accessibilityOptions.darkMode}
                    progress={ watchProgress } 
                    videoTitle={ video.title }
                    onClick={ handleVideoAction } 
                />

                { video.description && <Styled.Description  ref={ descriptionElement }>{ video.description }</Styled.Description> }

                { ( ctaText !== '' && ctaLink !== '' ) && (
                    <a href={ ctaLink }>
                        <Styled.CtaButton>{ ctaText }</Styled.CtaButton>
                    </a>
                )}

                <VideoMetaData
                    className={ inlinePlay ? 'inline-play is-active' : 'inline-play' }
                    accessibilityOptions={ accessibilityOptions }
                    duration={ translator.lookup( 'label.channel.min', { minutes: getVideoDuration( video.duration ) } ) }
                    episodes={ episodesLabel }
                    watchProgress={ watchProgress }
                />
            </Styled.Content>
        </Styled.VideoPromo>
    )
}